import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './Contact.css'; // Importa el archivo de estilos

const Contact = () => {
  return (
    <div className="containers">
      <Link to="/home" className="button-link">
        <FontAwesomeIcon icon={faArrowLeft} className="icon" />
      </Link>
      <div className="left-side">
        <div className="overlay-box">
          <p className="overlay-text">CONTACTANOS <br></br>SOMOS MNBA</p>
          <p className="overlay-subtext">Gracias por visitar nuestra experiencia virtual</p>
        </div>
        
        <img src="https://saltandomurosdotorg.files.wordpress.com/2013/01/mnba-neuquc3a9n.jpg" alt="Left" />
        <button className='button'>Contactar</button>
      </div>
      <div className="right-side">
        <img src="https://i.postimg.cc/ZKz05zcp/MNBA-nqn.jpg" alt="Right" />
      </div>
    </div>
  );
};

export default Contact;
